import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function   Mumbaitopanchganicab() {



  const cardData = {
    keyword: " Mumbai to Panchgani Cab",


"headingDescription": "Royal Route Cab offers reliable and comfortable Mumbai to Panchgani cab services, ensuring a smooth, safe, and scenic journey for families, couples, and weekend travelers. Panchgani is a charming hill station in the Sahyadri ranges known for its cool climate, lush green valleys, strawberry farms, and colonial-era charm, making it a perfect getaway from Mumbai. Our professional drivers and well-maintained vehicles ensure a stress-free travel experience throughout the journey. The Mumbai to Panchgani route covers approximately 240 to 260 km and takes around 5 to 6 hours depending on traffic and road conditions. We offer flexible booking options including one-way trips, round trips, and customized travel plans with transparent pricing and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, luxury cars, and Tempo Travellers suitable for all types of travelers. With easy online booking and 24/7 customer support, Royal Route Cab is your trusted partner for Mumbai to Panchgani travel.",

"topPlaces": [
  {
    "title": "Sydney Point",
    "description": "Sydney Point is one of the most famous viewpoints in Panchgani offering panoramic views of Krishna Valley, Dhom Dam, and surrounding hills. It is especially popular during sunrise and sunset when the entire valley glows with golden light, making it perfect for photography and relaxation."
  },
  {
    "title": "Parsi Point",
    "description": "Parsi Point is a scenic cliff viewpoint known for its breathtaking views of the Krishna Valley and lush green landscapes. It is a favorite stop for tourists and families, offering cool breezes, photo opportunities, and small local food stalls nearby."
  },
  {
    "title": "Table Land",
    "description": "Table Land is Asia’s second-largest volcanic plateau and the most iconic attraction in Panchgani. It offers vast open spaces, horse rides, paragliding activities, and stunning 360-degree views of hills and valleys, making it a must-visit spot."
  },
  {
    "title": "Mapro Garden",
    "description": "Mapro Garden is a popular tourist attraction known for strawberry gardens, chocolate factories, and delicious food products. Visitors can enjoy fresh strawberry cream, shakes, and shopping for Mapro products in a beautiful garden setting."
  },
  {
    "title": "Dhom Dam",
    "description": "Dhom Dam is a scenic water reservoir near Panchgani offering boating, photography, and peaceful lakeside views. It is surrounded by hills and is especially beautiful during monsoon and winter seasons."
  },
  {
    "title": "Lingmala Waterfall",
    "description": "Lingmala Waterfall is a stunning natural waterfall located between Mahabaleshwar and Panchgani. It is a monsoon favorite where water cascades from a great height, creating a refreshing and scenic atmosphere."
  },
  {
    "title": "Devrai Art Village",
    "description": "Devrai Art Village is a unique artistic space promoting tribal art, eco-friendly crafts, and handmade sculptures. It offers a cultural experience showcasing local artisans and sustainable art practices."
  },
  {
    "title": "Panchgani Strawberry Farms",
    "description": "Panchgani Strawberry Farms are famous for fresh strawberry picking experiences, especially during winter season. Visitors can walk through farms, taste fresh fruits, and enjoy rural agricultural tourism."
  },
  {
    "title": "Rajpuri Caves",
    "description": "Rajpuri Caves are ancient caves surrounded by water tanks and mythological significance. They are believed to have religious importance and offer a peaceful exploration experience near Panchgani."
  },
  {
    "title": "Bhilar Village (Book Village)",
    "description": "Bhilar Village, also known as India’s first ‘Book Village’, is a unique cultural initiative where books are displayed in homes instead of libraries. It promotes reading culture along with scenic rural tourism experience."
  }
],







services: [
  {
    name: "Mumbai to Panchgani Cab",
    description: "Mumbai to Panchgani cab service offers a scenic and comfortable journey to one of Maharashtra’s most charming hill stations. The route includes beautiful ghats, valleys, and greenery, making the drive relaxing and enjoyable. Ideal for families, couples, and weekend travelers, this service ensures safe travel with experienced drivers. Multiple vehicle options are available to suit different needs. It guarantees a refreshing and peaceful getaway."
  },
  {
    name: "Mumbai to Panchgani Taxi",
    description: "Mumbai to Panchgani taxi provides convenient and private travel with door-to-door pickup and drop. This service is perfect for travelers looking for a comfortable ride to this hill destination. Vehicles are well-maintained and driven by experienced chauffeurs. Suitable for short vacations and family trips. It ensures a smooth and stress-free journey."
  },
  {
    name: "Mumbai to Panchgani Cab Service",
    description: "Mumbai to Panchgani cab service is designed for safe and comfortable travel through scenic hill routes. This service is ideal for weekend getaways, romantic trips, and group outings. Vehicles are maintained for highway and ghat performance. Professional drivers ensure smooth travel. It ensures a reliable journey."
  },
  {
    name: "Mumbai to Panchgani Taxi Service",
    description: "Mumbai to Panchgani taxi service offers dependable intercity travel with a focus on comfort and safety. This service is suitable for tourists, families, and corporate travelers. Clean vehicles and trained drivers ensure a pleasant ride. Flexible scheduling allows easy planning. It guarantees a hassle-free experience."
  },
  {
    name: "Cab from Mumbai to Panchgani",
    description: "Cab from Mumbai to Panchgani provides a personalized travel experience with flexible stops at scenic viewpoints. Travelers can enjoy a relaxed and private journey. This service is ideal for families and small groups. Professional drivers ensure safe travel. It offers a memorable road trip experience."
  },
  {
    name: "Taxi from Mumbai to Panchgani",
    description: "Taxi from Mumbai to Panchgani offers a convenient and efficient way to travel to this hill station. With experienced drivers and comfortable vehicles, the journey is smooth and enjoyable. Door-to-door pickup adds convenience. Suitable for weekend trips and leisure travel. It ensures a reliable journey."
  },
  {
    name: "Mumbai to Panchgani Cab Booking",
    description: "Mumbai to Panchgani cab booking allows travelers to reserve their ride easily with flexible options. Customers can choose vehicle type, pickup location, and timing. Instant confirmation and transparent pricing ensure a hassle-free process. It simplifies travel planning."
  },
  {
    name: "Mumbai to Panchgani Taxi Booking Online",
    description: "Mumbai to Panchgani taxi booking online provides a quick and convenient way to book your journey. Customers can compare vehicle options and pricing easily. Secure payment and instant confirmation enhance convenience. It ensures availability during peak travel times."
  },
  {
    name: "Mumbai to Panchgani Cab Price",
    description: "Mumbai to Panchgani cab price varies based on vehicle type, travel timing, and trip type. Transparent pricing ensures no hidden charges. Budget-friendly sedan options and premium SUVs are available. It helps travelers plan their trip efficiently. It ensures value for money."
  },
  {
    name: "Mumbai to Panchgani Taxi Fare",
    description: "Mumbai to Panchgani taxi fare is designed to be affordable and competitive for hill travel. Fare depends on vehicle type and travel plan. Customers receive clear pricing details before booking. Multiple options suit different budgets. It ensures cost-effective travel."
  },
  {
    name: "Mumbai to Panchgani One Way Cab",
    description: "Mumbai to Panchgani one way cab is a cost-effective option for travelers needing a single-side drop. This service eliminates return charges and offers flexible travel timings. Ideal for quick getaways. Comfortable vehicles ensure a smooth ride. It is perfect for budget travel."
  },
  {
    name: "Mumbai to Panchgani Round Trip Taxi",
    description: "Mumbai to Panchgani round trip taxi is ideal for travelers planning a same-day or weekend return trip. This package includes pickup, drop, waiting time, and return travel. Flexible schedules make it convenient. Suitable for family outings and sightseeing. It ensures comfort and efficiency."
  },
  {
    name: "Mumbai to Panchgani Innova Cab",
    description: "Mumbai to Panchgani Innova cab is perfect for families and groups seeking spacious and comfortable travel. The vehicle offers ample seating and luggage space. Ideal for group trips. Professional drivers ensure safety. It provides a premium travel experience."
  },
  {
    name: "Mumbai to Panchgani Ertiga Cab",
    description: "Mumbai to Panchgani Ertiga cab is suitable for small groups and families looking for an affordable yet spacious ride. This vehicle offers comfortable seating and good mileage. It is ideal for budget-friendly travel. Drivers ensure smooth journeys. It ensures a pleasant experience."
  },
  {
    name: "Mumbai to Panchgani Sedan Cab",
    description: "Mumbai to Panchgani sedan cab is ideal for couples and small families seeking economical travel. Sedans offer smooth driving and comfort for hill journeys. This option is widely preferred for its affordability. Professional drivers ensure safe travel. It is perfect for a relaxed journey."
  },
  {
    name: "Mumbai to Panchgani SUV Taxi",
    description: "Mumbai to Panchgani SUV taxi provides extra space and better performance on hilly roads. SUVs offer stability and comfort during ghat travel. This option is ideal for families and corporate groups. Drivers ensure safe and reliable travel. It delivers a comfortable experience."
  },
  {
    name: "Cheap Mumbai to Panchgani Cab",
    description: "Cheap Mumbai to Panchgani cab offers budget-friendly travel options without compromising comfort and safety. This service is ideal for cost-conscious travelers. Economical sedan options help reduce travel costs. Transparent pricing ensures no hidden charges. It is perfect for affordable trips."
  },
  {
    name: "Best Mumbai to Panchgani Taxi Service",
    description: "Best Mumbai to Panchgani taxi service ensures a premium travel experience with top-quality vehicles and professional drivers. This service focuses on punctuality, safety, and customer satisfaction. Multiple vehicle options are available for different needs. Transparent pricing builds trust. It guarantees a reliable and comfortable journey."
  }
],

tableData: [
  ["Mumbai to Panchgani Cab", "Mumbai to Panchgani Taxi"],
  ["Mumbai to Panchgani Cab Service", "Mumbai to Panchgani Taxi Service"],
  ["Cab from Mumbai to Panchgani", "Taxi from Mumbai to Panchgani"],
  ["Mumbai to Panchgani Cab Booking", "Mumbai to Panchgani Taxi Booking Online"],
  ["Mumbai to Panchgani Cab Price", "Mumbai to Panchgani Taxi Fare"],
  ["Mumbai to Panchgani One Way Cab", "Mumbai to Panchgani Round Trip Taxi"],
  ["Mumbai to Panchgani Innova Cab", "Mumbai to Panchgani Ertiga Cab"],
  ["Mumbai to Panchgani Sedan Cab", "Mumbai to Panchgani SUV Taxi"],
  ["Cheap Mumbai to Panchgani Cab", "Best Mumbai to Panchgani Taxi Service"]
],


whychoose: [
  {
    WhyChooseheading: "Comfortable Mumbai to Panchgani Travel",
    WhyChoosedescription: "Royal Route Cabs offers a smooth and comfortable Mumbai to Panchgani cab service, perfect for hill station trips, family vacations, and weekend getaways."
  },
  {
    WhyChooseheading: "Experienced Ghat Route Drivers",
    WhyChoosedescription: "Our drivers are well-trained for hill and ghat routes, ensuring safe driving and smooth navigation through winding roads to Panchgani."
  },
  {
    WhyChooseheading: "Transparent Pricing with No Hidden Charges",
    WhyChoosedescription: "Royal Route Cabs provides clear and upfront pricing including tolls, driver allowance, and all charges with no hidden costs."
  },
  {
    WhyChooseheading: "24/7 Cab Service Availability",
    WhyChoosedescription: "Our Mumbai to Panchgani cab service operates 24/7, allowing flexible departure anytime as per your convenience."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles are fully air-conditioned, well-maintained, and regularly cleaned to ensure a relaxing travel experience."
  },
  {
    WhyChooseheading: "One Way & Round Trip Options",
    WhyChoosedescription: "Choose from one-way cab service, round-trip bookings, or same-day return options for Panchgani trips."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "We offer sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, and Tempo Travellers for families and group travel."
  },
  {
    WhyChooseheading: "Trusted Hill Station Travel Service",
    WhyChoosedescription: "Royal Route Cabs is trusted by travelers for Mumbai to Panchgani cab bookings due to punctual service and reliable drivers."
  }
]

};

const faqData = [
  { question: "Do you provide Mumbai to Panchgani cab service?", answer: "Yes, Royal Route Cabs offers reliable cab services from Mumbai to Panchgani for both one-way and round trips." },
  { question: "What is the distance between Mumbai and Panchgani?", answer: "The distance is approximately 240 to 260 km and takes around 5 to 6 hours depending on traffic and route." },
  { question: "Is cab service available 24 hours?", answer: "Yes, our Mumbai to Panchgani cab service operates 24/7." },
  { question: "Which vehicles are available for this route?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, Innova Crysta, and Tempo Travellers." },
  { question: "Can I book a one-way cab?", answer: "Yes, we provide both one-way and round-trip cab services." },
  { question: "Are vehicles air-conditioned?", answer: "Yes, all vehicles are fully air-conditioned for comfortable travel." },
  { question: "Do you provide doorstep pickup?", answer: "Yes, we offer pickup from home, hotel, and airport anywhere in Mumbai." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended, especially during weekends and peak tourist seasons." },
  { question: "Do you provide same-day return trips?", answer: "Yes, we offer same-day return cab services for Mumbai to Panchgani trips." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly for passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Amit Kulkarni",
    feedback: "The Mumbai to Panchgani cab service with Royal Route Cabs was very smooth and enjoyable. The hill drive was comfortable and the journey felt safe throughout.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Sneha Deshpande",
    feedback: "Excellent experience traveling from Mumbai to Panchgani. The cab was clean, the ride was relaxing, and the service was reliable and well-managed.",
    rating: 5
  }
];





















  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman taxi", link: "Mumbai-to-Daman-Taxi" },
    { place: "/images/keyword/26.jpg", text: "Mumbai to Vapi cab", link: "Mumbai-to-Vapi-Cab" },
    { place: "/images/keyword/27.jpg", text: "Mumbai to Bangalore cab", link: "Mumbai-to-Bangalore-Cab" }
  ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Panchgani Cab",
  "image": "https://www.royalroutecabs.com/assets/images/mumbai-to-panchgani-cab.jpg", // replace if needed
  "description": "Book Mumbai to Panchgani cab with Royal Route Cabs for a comfortable hill station journey. Choose from sedan, SUV, Innova, and luxury cars for one-way and round-trip taxi service with 24x7 availability and experienced drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Royal Route Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "ratingCount": "3200",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2800", // adjust if needed
    "availability": "https://schema.org/InStock",
    "url": "https://www.royalroutecabs.com/mumbai-to-panchgani-cab"
  }
};



  return (
    <div>

<Helmet>
  <title>Mumbai to Panchgani Cab | Call:- +91 9529877342 | Best Outstation Cab Service</title>

  <meta
    name="description"
    content="Book Mumbai to Panchgani cab at best price with Royal Route Cabs. One-way & round-trip taxi service with sedan, SUV, Innova & luxury cars. Safe, reliable & 24x7 available."
  />

  <meta
    name="keywords"
    content="mumbai to panchgani cab, mumbai to panchgani taxi, mumbai to panchgani cab service, mumbai to panchgani taxi service, cab from mumbai to panchgani, taxi from mumbai to panchgani, mumbai to panchgani cab booking, mumbai to panchgani taxi booking online, mumbai to panchgani cab price, mumbai to panchgani taxi fare, mumbai to panchgani one way cab, mumbai to panchgani round trip taxi, mumbai to panchgani innova cab, mumbai to panchgani ertiga cab, mumbai to panchgani sedan cab, mumbai to panchgani suv taxi, cheap mumbai to panchgani cab, best mumbai to panchgani taxi service"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



      <div
        className="breadcrumb-wrapper section-padding bg-cover"
        style={{ backgroundImage: "url('/img/breadcrumb-bg.jpeg')" }}
      >
        <div className="container-fluid">
          <div className="page-heading">
            <h1 className="text-center">{cardData.keyword}</h1>
          </div>
        </div>
      </div>














      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/17.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Royal Route Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


          <div className="keyword-grid">
  {cardData.tableData.flat().map((keyword, index) => (
    <div key={index} className="keyword-item">
      <span className="keyword-bullet">-</span>
      {keyword}
    </div>
  ))}
</div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title text-white">
                  Why Choose <span>Royal Route Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Royal Route Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529877342" className="pc-call">+91 9529877342</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529877342"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529877342" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@royalroutecabs.com" className="pc-email">
                      booking@royalroutecabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Royal Route Cab</strong><br />
                      Shop Number 57, Prabhat Colony Opp. Panbai International School Vimladevi Road,Santacruz(E) Mumbai Maharashtra-400055.


                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitopanchganicab;